export const TRADE_TIMES = {
  TWELVE_HOUR: "12h",
  ONE_DAY: "1d",
  ONE_WEEK: "1w",
};
